// removed by extract-text-webpack-plugin
module.exports = {"container":"build_v16-container-geUr33k9McG","container--inactive":"build_v16-container--inactive-fm7nOzkVwIm","icon":"build_v16-icon-iGtbYK58ooC","icon-dot":"build_v16-icon-dot-2CAjMID4a4c","count":"build_v16-count-cTIcVgTOveS"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/chats_notificator/index.css
// module id = 291
// module chunks = 2